import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import { ArrowLeft, ArrowRight } from "@mui/icons-material";
import Images from "../../../assets";
import DotStrip from "./dotStrip";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";


const TOKENS = {
    radius: 5,
    stroke: "#E9E9E9",
    panel: "#FFFFFF",
    dotActive: "#E5007E",
    dotIdle: "#DADADA",
    text: "#111111",
};

export default function ProductImageGalleryRightNav({
                                                        images = [],
                                                        currentIndex = 0,
                                                        onPrev,
                                                        onNext,
                                                    }) {
    const total = images.length || 1;
    const cur = Math.min(Math.max(currentIndex, 0), total - 1);
    const src = images[cur]?.src || images[cur];

    return (
        <Box
            sx={{
                width: "90%",
                minWidth: 0,
                display: "grid",
                gridTemplateColumns: {
                    xs: "1fr 28px",
                    sm: "1fr 32px",
                    md: "minmax(380px,1fr) 36px",
                    lg: "minmax(540px,1fr) 38px",
                },
                columnGap: { xs: 1, md: 1.25 },
                alignItems: "start",
            }}
        >
            {/* ΕΙΚΟΝΑ */}
            <Box
                sx={{
                    minWidth: 0,
                    justifySelf: "stretch",
                    alignSelf: "stretch",
                    width: "100%",
                    aspectRatio: "4 / 3",
                    maxHeight: { xs: 320, md: 420, lg: 480 },
                    bgcolor: TOKENS.panel,
                    border: `1px solid ${TOKENS.stroke}`,
                    borderRadius: TOKENS.radius,
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    p: { xs: 1, md: 2 },
                }}
            >
                <Box
                    sx={{
                        width: "100%",
                        height: "100%",
                        backgroundImage: `url(${src})`,
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                    }}
                />

            </Box>

            <Box
                sx={{
                    width: { xs: 28, sm: 32, md: 36, lg: 40 },
                    height: { xs: "clamp(120px, 24vh, 160px)", md: "clamp(140px, 26vh, 176px)" },
                    alignSelf: "center",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "space-between",
                    py: { xs: 0.5, md: 1 },
                    gap: { xs: 0.5, md: 1 },
                }}
            >
                <Box sx={{ bgcolor: TOKENS.panel, borderRadius: TOKENS.radius }}>
                    <IconButton
                        size="small"
                        onClick={onPrev}
                        disabled={cur === 0}
                        sx={{
                            width: { xs: 22, md: 26 },
                            height: { xs: 22, md: 26 },
                        }}
                    >
                        <ArrowBackIcon sx={{ fontSize: { xs: 18, md: 20 } }} />
                    </IconButton>
                </Box>

                <DotStrip count={images.length} cur={cur} />

                <Box sx={{ bgcolor: TOKENS.panel, borderRadius: TOKENS.radius }}>
                    <IconButton
                        size="small"
                        onClick={onNext}
                        disabled={cur === total - 1}
                        sx={{
                            width: { xs: 22, md: 26 },
                            height: { xs: 22, md: 26 },
                        }}
                    >
                        <ArrowForwardIcon sx={{ fontSize: { xs: 18, md: 20 } }} />
                    </IconButton>
                </Box>
            </Box>
        </Box>
    );
}
